import { useCallback } from 'react'
import { functional } from '@think-internet/zeus-frontend-package'
import Routes from '../../../redux/routes'
import { useDispatch, useSelector } from 'react-redux'
import props from '../../../redux/props'
import { setLocal } from '../../../redux/action/local'
import { YearReport } from '../../../types/Controlling/YearReport'

type Pull = (year: number) => Promise<void>

const useLoadControllingYearReport = (companyUUID?: string, kostenstelleUUID?: string): [YearReport | null, Pull] => {
  const dispatch = useDispatch()
  const getYearReport = functional.use(Routes.CONTROLLING_LOAD_YEAR_REPORT)
  const yearReport: YearReport = useSelector((s) => s[props.CONTROLLING_YEAR_REPORT])

  const pull = useCallback(
    async (year?: number) => {
      if (!!companyUUID && !!kostenstelleUUID && !!year) {
        const offerEntries = await getYearReport({ companyUUID, kostenstelleUUID, year })
        if (offerEntries) {
          dispatch(setLocal(props.CONTROLLING_YEAR_REPORT, offerEntries))
        }
      } else if (!!yearReport) {
        const offerEntries = await getYearReport({
          companyUUID: yearReport.company.uuid,
          kostenstelleUUID: yearReport.kostenstelle.uuid,
          year: yearReport.year,
        })
        if (offerEntries) {
          dispatch(setLocal(props.CONTROLLING_YEAR_REPORT, offerEntries))
        }
      }
    },
    [getYearReport, companyUUID, kostenstelleUUID, dispatch, yearReport],
  )

  return [yearReport, pull]
}

export default useLoadControllingYearReport
